/** Header sent with API requests when super-admin scopes actions to a tenant. */
export const SCOPED_TENANT_HEADER = 'X-Tenant-Id' as const;

export const TENANT_SCOPE_REQUIRED_MESSAGE = 'Select a tenant to load data for this scope.';

const STORAGE_KEY = 'slai-scoped-tenant-id';

/** `undefined` = not hydrated from storage yet; `null` = no scoped tenant */
let cachedTenantId: string | null | undefined = undefined;

function readFromStorage(): string | null {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw?.trim() || null;
}

/** Current scoped tenant UUID for outbound requests, or null if not scoped. */
export function getScopedTenantId(): string | null {
    if (cachedTenantId !== undefined) {
        return cachedTenantId;
    }
    cachedTenantId = readFromStorage();
    return cachedTenantId;
}

export function setScopedTenantId(tenantId: string | null | undefined): void {
    const normalized = typeof tenantId === 'string' && tenantId.trim().length > 0 ? tenantId.trim() : null;
    cachedTenantId = normalized;
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    if (normalized) {
        sessionStorage.setItem(STORAGE_KEY, normalized);
    } else {
        sessionStorage.removeItem(STORAGE_KEY);
    }
}

export function clearScopedTenantId(): void {
    setScopedTenantId(null);
}
